import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useEmpresas() {
    const [empresas, setEmpresas] = useState({});

    useEffect(() => {
        axios.get('http://provin.ind.br:5000/nomesEmpresas')
            .then(response => {
                const map = {};
                response.data.forEach(empresa => {
                    map[empresa.codigo] = empresa.nome;
                });
                setEmpresas(map);
            })
            .catch(err => console.error('Erro ao buscar empresas:', err))
    }, []);

    return { empresas };
}